<template>
  <div>
    <pop-distribute-goods-num ref="popDistributeGoodsNumRef"></pop-distribute-goods-num>
    <pop-my-settle ref="popMySettleRef"></pop-my-settle>
    <div class="forms-container" style="display: flex;gap: 10px;justify-content: flex-end;margin-bottom: 10px;">
      <add-daren-pop :isSetContact="isSetContact"></add-daren-pop>
    </div>
    <div class="forms-container">
      <el-form :model="searchForm" class="search-form" ref="searchFormRef">
        <el-form-item label="" prop="searchContent">
          <el-input
              style="width:300px"
              :maxlength="100"
              v-model="searchForm.searchContent"
              placeholder="达人昵称/抖音ID"
          />
        </el-form-item>
        <el-form-item>
          <el-date-picker
              v-model="searchForm.timeArr"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="daterange"
              range-separator="-"
              start-placeholder="绑定开始日期"
              end-placeholder="绑定结束日期"
              :default-time="['00:00:00', '23:59:59']"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <!-- 操作按钮 -->
          <el-button type="warning" @click="onFormSearch">查询</el-button>
          <el-button type="warning" plain @click="onFormReset">重置</el-button>
          <el-button type="primary" @click="onExport" :disabled="exportLoading" :loading="exportLoading">导出</el-button>
        </el-form-item>
        <contact-info @getIsSetFun="handleIsSetContact"></contact-info>
      </el-form>
    </div>
    <el-table :data="tableList.list" v-loading="loading" highlight-current-row border style="width: 100%">
      <el-table-column prop="id" label="用户ID" width="300"/>
      <el-table-column prop="nickname" label="抖音昵称" />
      <el-table-column prop="douyinid" label="抖音ID" />
      <el-table-column prop="phone" label="注册手机号" >
        <template slot-scope="scope">
          {{ scope.row.phone || '--' }}
        </template>
      </el-table-column>
      <el-table-column prop="distributeGoodsNum" label="推广商品数" >
        <template slot-scope="scope">
<!--          <el-link v-if="scope.row.distributeGoodsNum" type="text" @click="handleDistributeGoodsNum(scope.row)">-->
<!--            {{scope.row.distributeGoodsNum }}-->
<!--          </el-link>-->
<!--          <div @click="handleDistributeGoodsNum(scope.row)" v-else>-->
<!--            {{scope.row.distributeGoodsNum }}-->
<!--          </div>-->
          {{scope.row.distributeGoodsNum }}
        </template>
      </el-table-column>
      <el-table-column label="达人佣金" >
        <template #header>
          <div style="display: flex;gap: 6px;align-items: baseline;">
            达人佣金
            <el-tooltip effect="dark" placement="top" content="该达人与您合作期间已经结算的佣金">
              <el-icon class="el-icon-question" />
            </el-tooltip>
          </div>
        </template>
        <template slot-scope="scope">
          <el-link v-if="scope.row.darenCommissionBd" type="text" @click="handleMySettle(scope.row)">
            {{scope.row.darenCommissionBd }}
          </el-link>
          <div v-else>
            {{scope.row.darenCommissionBd }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="我的服务费" >
        <template #header>
          <div style="display: flex;gap: 6px;align-items: baseline;">
            我的服务费
            <el-tooltip effect="dark" placement="top" content="该达人与您合作期间，您已经获得的服务费">
              <el-icon class="el-icon-question" />
            </el-tooltip>
          </div>
        </template>
        <template slot-scope="scope">
          {{scope.row.agentCommissionBd }}
        </template>
      </el-table-column>
      <el-table-column prop="registerTime" label="注册时间" width="180" />
      <el-table-column prop="bindTime" label="绑定时间" width="180" />
      <el-table-column label="操作" width="120" align="left">
        <template slot-scope="{row}">
          <el-link type="text" @click="handleUnbinding(row)">
            <i class="el-icon-setting"></i> 解绑
          </el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        v-if="tableList.total > 0"
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="tableList.currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="tableList.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableList.total"
    >
    </el-pagination>

  </div>
</template>

<script>
import debounce from "@/utils/debounce.js";
import poi from "@/api/poi";
import AddDarenPop from "./addDarenPop.vue";
import ContactInfo from "../../../miniProgram/poiCps/components/contactInfo.vue";
import PopDistributeGoodsNum from "./popDistributeGoodsNum.vue";
import PopMySettle from "./popMySettle.vue";
import {goExportCenter} from "../../../../../utils/tool";
import {getUserUUID} from "../../../../../utils/auth";
const PoiModel = new poi();
export default {
  components: {
    ContactInfo,
    AddDarenPop,
    PopDistributeGoodsNum,
    PopMySettle
  },
  data() {
    return {
      searchForm: {
        searchContent: '',
        timeArr: null
      },
      params: {
        pageNo: 1,
        pageSize: 10,
      },
      isSetContact: false,
      loading: false,
      tableList:{
        pageSize: 10,
        currentPage: 1,
        total: 0,
        list:[
        ],
      },
      exportLoading: false
    }
  },
  created() {
    this.getList();
  },
  methods:{
    handleMySettle(row){
      this.$refs.popMySettleRef.open({
        userUUID: row.userUUID,
        fansId: row.fansId
      })
    },
    handleDistributeGoodsNum(row){
      this.$refs.popDistributeGoodsNumRef.open({
        userUUID: row.userUUID,
        fansId: row.fansId
      })
    },
    handleIsSetContact(value){
      this.isSetContact = value;
    },
    async handleUnbinding(row){
      await this.$confirm(`是否确认解绑`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      const res = await PoiModel.unbindDaren({
        fansId: row.fansId,
      })
      if(!res.data.success) {
        this.$message.error(res.data.message);
        return;
      }
      this.$message.success(res.data.message);
      this.getList();
    },
    getParams(){
      const params = {
        userUUID: getUserUUID(),
        ...this.searchForm
      }
      params.bindStartTime = this.searchForm.timeArr ? this.searchForm.timeArr[0] : '';
      params.bindEndTime = this.searchForm.timeArr ? this.searchForm.timeArr[1] : '';
      delete params.timeArr
      return {
        ...this.openParams,
        ...params
      }
    },
    async getList() {
      this.loading = true
      const res = await PoiModel.getDarenList({
        ...this.getParams(),
        pageNo: this.params.pageNo,
        pageSize: this.params.pageSize,
      });
      if(res.data.code !== 200) {
        this.$message.error(res.data.message);
        return;
      }
      this.tableList.list = res.data.data.list || [];
      this.tableList.total = res.data.data.total || 0;
      this.loading = false;
      this.tableList.currentPage = res.data.data.pageNo;
      this.tableList.pageSize = res.data.data.pageSize;
    },
    onFormSearch() {
      debounce(
          () => {
            this.$refs['searchFormRef'].validate((valid) => {
              if (valid) {
                this.params.pageNo = 1;
                this.getList();
              } else {
                console.log('error submit!!');
                return false;
              }
            });
          },
          500,
          true
      );
    },
    reset() {
      this.searchForm = {
        searchContent: '',
        timeArr: null
      }
      this.params.pageNo = 1;
      this.params.pageSize = 10;
      this.$refs['searchFormRef'] && this.$refs['searchFormRef'].resetFields();
    },
    onFormReset() {
      debounce(() => {
        this.reset()
        this.getList()
      }, 1000, true)
    },
    handleSizeChange(val) {
      this.params.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.params.pageNo = val;
      this.getList();
    },
    async onExport(){
      const params = this.getParams();
      if(!params.bindStartTime || !params.bindEndTime){
        this.$message.error('请选择日期')
        return;
      }
      this.exportLoading = true;
      const res = await PoiModel.exportMyDarenListExport({
        ...params,
      }).finally(()=>{
        this.exportLoading = false;
      });
      if(!res.data.success) {
        this.$message.error(res.data.message);
        return;
      }
      this.exportLoading = false;
      await goExportCenter()
    }
  },
}
</script>

<style scoped lang="less">
.pagination {
  margin-top: 20px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/douyin/poiDistribution/components/list.vue